export const getMapValue = (obj, key) => {
  if (obj.hasOwnProperty(key))
    return obj[key]; 
}